module.exports = __webpack_public_path__ + "static/img/reviewfail@2x.d33c450a.png";